
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotesDatashareService {
  private subTabSubject = new BehaviorSubject<number>(1); // default to sub-tab 1
  subTab$ = this.subTabSubject.asObservable();
  private isActiveSubject = new BehaviorSubject<number>(1)
  isActive$ = this.isActiveSubject.asObservable()
  setisActive(num:number) {
    this.isActiveSubject.next(num)
  }
  private selectedNotesSubject = new BehaviorSubject<string[]>(['Note1','Note2']);
  selectedNotes$ = this.selectedNotesSubject.asObservable();

  setSubTab(tab: number) {
    this.subTabSubject.next(tab);
  }
  private isdirtysubject = new BehaviorSubject<boolean>(false)
  isdirty$ = this.isdirtysubject.asObservable()
  setisdirty(value: boolean) {
    this.isdirtysubject.next(value)
  }
  // Set full array
  setSelectedNotes(notes: string[]) {
    this.selectedNotesSubject.next(notes);
  }
  // Add one note
  addNote(note: string) {
    const current = this.selectedNotesSubject.getValue();
    if (!current.includes(note)) {
      this.selectedNotesSubject.next([...current, note]);
    }
  }
  // Remove one note
  removeNote(note: string) {
    const updated = this.selectedNotesSubject.getValue().filter(n => n !== note);
    this.selectedNotesSubject.next(updated);
  }
  // Clear all
  clearNotes() {
    this.selectedNotesSubject.next([]);
  }

}

